<template>
	<div class="search-area" id="search-area">
		<div class="container">
			<router-link class="logo" :to="{ name: 'Home' }">LOGO</router-link>

			<div class="search">
				<div class="search-l">
					<img src="../assets/user-center/home/icon04.png" alt="">
					<span>搜索商品名称</span>
				</div>
				<div class="search-btn">搜索</div>
			</div>

			<div class="total">
				<div class="total-l">
					<div class="total-l-tag">3</div>
				</div>
				<div class="total-txt" @click="goToShoppindCart">购物车</div>
			</div>

			<!-- <div class="shopping-cart" @mouseenter="showShoppingCartList" @mouseleave="showShoppingCartList">
	  			<div class="shopping-cart-header">
	  				<span>我的购物车</span>
		  			<span class="shopping-cart-icon"></span>
			  		<span class="shopping-cart-number">{{ shoppingCartNumber }}</span>
	  			</div>
		  		<div class="shopping-cart-list" v-show="isShowShoppingCartList">
		  			<p v-if="myShoppingCart.length == 0" class="has-nothing">
		  				亲，您当前的购物车没有商品呢~
		  			</p>
	  				<ul>
	  					<li v-for="product in myShoppingCart" class="product-item">
	  						<img :src="productImageURL(product.id)">
	  						<div class="product-info">{{ product.name }}</div>
	  						<div class="product-number">
	  							<p><span class="price">￥{{ product.price }}</span> × {{ product.number }}</p>
	  							<p class="delete-product">删除</p>
	  						</div>
	  					</li>
	  				</ul>
	  				<div class="total">
						<span>共{{ shoppingCartNumber }}件商品</span>
						<span>共计￥{{ totalMoneyOfShoppingCart }}</span>
						<span @click="goToShoppindCart">去购物车</span>
	  				</div>
		  		</div>
		  	</div> -->
		</div>
	</div>
</template>

<script>
	import products from '../../static/products.js'

	export default {
		name: 'Product',
		data() {
			return {
				allProducts: products,
				isShowShoppingCartList: false,
				// 购物车
				myShoppingCart: [
					{
						id: 1,
						name: '京东海外直采 越南巴沙鱼柳（去皮） BAP认证 450g 2片/袋 原装进口 火锅烧烤食材',
						price: 11122.91,
						number: 1,
						imgUrl: '#',
					},
					{
						id: 2,
						name: '【云南褚柑正品 产地直发】现摘云南褚时健实建禇柑 5KG礼盒装 新鲜柑橘 生鲜水果哀牢山沃柑非褚橙 一级M10斤装',
						price: 1234.80,
						number: 3,
						imgUrl: '#',
					},
					{
						id: 1,
						name: '京东海外直采 越南巴沙鱼柳（去皮） BAP认证 450g 2片/袋 原装进口 火锅烧烤食材',
						price: 22.90,
						number: 1,
						imgUrl: '#',
					},
					{
						id: 2,
						name: '【云南褚柑正品 产地直发】现摘云南褚时健实建禇柑 5KG礼盒装 新鲜柑橘 生鲜水果哀牢山沃柑非褚橙 一级M10斤装',
						price: 12.80,
						number: 3,
						imgUrl: '#',
					}, {
						id: 1,
						name: '京东海外直采 越南巴沙鱼柳（去皮） BAP认证 450g 2片/袋 原装进口 火锅烧烤食材',
						price: 22.90,
						number: 1,
						imgUrl: '#',
					},
				],
				hotSearchIds: [3, 4, 6, 13, 15, 22, 27, 30, 33, 39, 42, 44],
			}
		},
		computed: {
			// 购物车总商品数量
			shoppingCartNumber: function () {
				var count = 0;
				for (var i = 0; i < this.myShoppingCart.length; i++) {
					count += this.myShoppingCart[i].number;
				}
				return count;
			},
			// 购物车总额
			totalMoneyOfShoppingCart: function () {
				var count = 0;
				for (var i = 0; i < this.myShoppingCart.length; i++) {
					count += this.myShoppingCart[i].number * this.myShoppingCart[i].price;
				}
				return (new Number(count)).toFixed(2);
			},
		},
		methods: {
			showShoppingCartList: function () {
				this.isShowShoppingCartList = !this.isShowShoppingCartList;
			},
			productImageURL: function (id) {
				// require用法
				return require('../assets/product-img/' + id + '.jpg');
			},
			goToShoppindCart: function () {
				this.$router.push({ path: 'shopping-cart' });
			},
			getProductInfo: function (id) {
				return this.allProducts[id - 1];
			},
		},
	};
</script>

<style scoped lang="scss">
	/*搜索区域 */
	.search-area {
		width: 100%;
		padding: 16px var(--page-gutter);
		box-sizing: border-box;

		@media (min-width: 768px) {
			padding: 24px var(--page-gutter);
		}

		@media (min-width: 1280px) {
			padding: 32px var(--page-gutter);
		}
	}

	.search-area .container {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0;
		gap: 12px;
		flex-wrap: wrap;
	}

	.search-area .logo {
		/* position: absolute; */
		width: 80px;
		height: 40px;
		border-radius: 4px;
		/* // background: url('../assets/main-view/logo1.png') no-repeat; */
		background: #FD3B00;
		background-size: 80px 40px;
		cursor: pointer;
		display: inline-block;

		color: #FFFFFF;
		text-align: center;
		line-height: 40px;
	}

	/* 搜索 */
	.search {
		flex: 1;
		min-width: 180px;
		max-width: 889px;
		padding: 4px;
		border-radius: 8px;
		border: 1px solid #FD3B00;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.search-l {
			display: flex;
			align-items: center;
			margin-left: 20px;

			img {
				width: 14px;
				height: 14px;
			}

			span {
				font-size: 14px;
				color: #BFBFBF;
				margin-left: 16px;
			}
		}

		.search-btn {
			width: 72px;
			height: 34px;
			background: #FD3B00;
			border-radius: 8px 8px 8px 8px;
			color: #fff;
			font-size: 14px;
			text-align: center;
			line-height: 34px;
		}
	}

	/* 购物车 */
	.search-area .shopping-cart {
		position: absolute;
		top: 20px;
		right: 80px;
		display: inline-block;
		border: 1px solid #999;
		height: 34px;
		width: 150px;
		line-height: 34px;
		/*padding: 0 20px;*/

	}

	.search-area .shopping-cart .shopping-cart-header {
		position: absolute;
		top: 0.5px;
		right: 0.5px;
		width: 149px;
		height: 30px;
		/*background-color: red;*/
		/*border: 1px solid #999;*/
	}

	.search-area .shopping-cart:hover .shopping-cart-header {
		background-color: #fff;
		border-bottom: 1px solid #fff;
		z-index: 20;
	}

	.search-area .shopping-cart .shopping-cart-header span:first-child {
		margin-left: 20px;
		color: #129934;
	}

	.search-area .shopping-cart .shopping-cart-icon {
		display: inline-block;
		width: 22.2px;
		height: 19.2px;
		/*background-color: red;*/
		/*margin-top: */
		position: absolute;
		top: 5px;
		right: 20px;
		background: url('../assets/app-header/icons/shopping-cart.png') no-repeat;
		background-size: 22.2px 19.2px;
		background-position: 0 0;
	}

	.search-area .shopping-cart .shopping-cart-number {
		display: inline-block;
		width: 20px;
		height: 20px;
		line-height: 20px;
		text-align: center;
		/*background-color: red;*/
		font-size: 10px;
		font-weight: bold;
		color: #12ab34;
		position: absolute;
		top: 0px;
		right: 19px;
	}

	.search-area .shopping-cart .shopping-cart-list {
		/*box-sizing: border-box;*/
		position: absolute;
		top: 30px;
		right: -1px;
		width: 460px;
		background-color: #fff;
		border: 1px solid #999;
		font-size: 14px;
		z-index: 10;
		/*background-color: red;*/
	}

	.search-area .shopping-cart .shopping-cart-list ul {
		min-height: 100px;
		max-height: 320px;
		overflow: auto;
	}

	.search-area .shopping-cart .shopping-cart-list .product-item {
		box-sizing: border-box;
		height: 80px;
		/*width: */
		padding: 5px;
		border-bottom: 1px solid #eee;
		position: relative;
	}

	.search-area .shopping-cart .shopping-cart-list .product-item:hover {
		background-color: #eee;
	}

	.search-area .shopping-cart .shopping-cart-list .product-item img {
		box-sizing: border-box;
		width: 70px;
		height: 70px;
		border: 1px solid #eee;
	}

	.search-area .shopping-cart .shopping-cart-list .product-item .product-info {
		position: absolute;
		top: 5px;
		right: 5px;
		margin: 5px 95px;
		/*margin-bottom: 5px;*/
		height: 60px;
		line-height: 20px;
		/*background-color: red;*/
		overflow: hidden;
	}

	.search-area .shopping-cart .shopping-cart-list .product-item .product-number {
		position: absolute;
		top: 10px;
		right: 10px;
		height: 20px;
		line-height: 20px;
		/*background-color: red;*/
	}

	.search-area .shopping-cart .shopping-cart-list .product-item .product-number .price {
		color: red;
	}

	.search-area .shopping-cart .shopping-cart-list .product-item .delete-product {
		float: right;
		margin-right: 10px;
		/*font-size: 14px;*/
	}

	.search-area .shopping-cart .shopping-cart-list .product-item .delete-product:hover {
		cursor: pointer;
		color: red;
	}

	.total {
		width: 103px;
		height: 42px;
		background: #FFFFFF;
		border-radius: 8px;
		border: 1px solid #FD3B00;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}

	.total>.total-l {
		width: 16px;
		height: 16px;
		background: url('../../static/images/icon/icon01.png');
		background-size: cover;
		position: relative;
	}

	.total>.total-l>.total-l-tag {
		width: 18px;
		height: 18px;
		text-align: center;
		line-height: 18px;
		background: #FF4133;
		font-size: 12px;
		color: #FFFFFF;
		border-radius: 50%;
		position: absolute;
		top: -9px;
		right: -9px;
	}

	.total>.total-txt {
		font-size: 14px;
		color: #FD3B00;
		margin-left: 8px;
	}
</style>


// WEBPACK FOOTER //
// src/components/SearchArea.vue